module.exports = __webpack_public_path__ + "img/resort-04.dc5ca984.jpg";